import type { TimeSeriesView } from "~/modules/token_timeseries/types";

export function calculateTooltipTotal(series: TimeSeriesView[]) {
    return series.reduce((total, each) => {
        const pointValue = each.item.points[0]?.[1] ?? 0;
        return total + pointValue * (each.invertYAxis ? -1 : 1);
    }, 0);
}
